:host {
  display: block;
  max-width: 1400px;
  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 640px) {
  :host {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media (min-width: 960px) {
  :host {
    padding-left: 40px;
    padding-right: 40px;
  }
}
